import React, { useEffect, useState } from "react";
import { Carousel } from "antd";
// import carousel from "../../utils/carousel";
import "./carousel.css";
import GradientButton from "../Button/GradientButton";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCarouselImages } from "../../slices/courseraSlice";
import { getS3Media } from "../../services/awsServices";
import LoadingCom from "../LoadingCom";

const contentStyle = {
  maxHeight: "300px",
  color: "#FFF",
  // lineHeight: "160px",
  // textAlign: "center",
  // background: `linear-gradient(to right, rgba(227, 48, 46, 0.15), rgba(255, 107, 56, 0.15), rgba(255, 163, 128, 0.15))`, // Updated gradient background with transparency
  // backgroundSize: "cover",
  // backgroundRepeat: "no-repeat",
  // backgroundPosition: "center",
  // borderRadius: "15px",
  // zIndex: 9,
};
const DashboardCarousel = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [carouselData, SetCaroselData] = useState();
  const [loading, setLoading] = useState(false);
  console.log("🚀 ~ DashboardCarousel ~ loading:", loading);
  console.log(
    "🚀 ~ DashboardCarousel ~ carouselData:"
    // carouselData[0].Data[0].Title
  );
  const onChange = (currentSlide) => {
    console.log(currentSlide);
  };
  // useEffect(() => {
  //   dispatch(getCarouselImages())
  //     .unwrap()
  //     .then((res) => {
  //       console.log(res, "Responseeeeeeeeeeeee");
  //       const response = res.data;
  //       SetCaroselData(res.data);
  //     })
  //     .catch((err) => console.log(err));
  // }, []);
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const response = await dispatch(getCarouselImages()).unwrap();
        const data = response.data;
        console.log(data, "====getCarouselImages:scajjnc");
        
        const updatedData = await Promise.all(
          data.map(async (item) => {
            const updatedItemData = await Promise.all(
              item.Data.map(async (values) => {
                try {
                  const imageUrlRes = await getS3Media(values.ImageUrl);
                  return {
                    ...values,
                    ImageUrl: imageUrlRes.data.url,
                  };
                } catch (error) {
                  console.error("Error fetching image URL:", error);
                  return values; // Return original values if fetching fails
                }
              })
            );
            return {
              ...item,
              Data: updatedItemData,
            };
          })
        );
        console.log(":rocket: ~ fetchData ~ updatedData:", updatedData);
        // SetCaroselData(response.data);
        SetCaroselData(updatedData);
        setLoading(false);
      } catch (error) {
        // setError(error);
        setLoading(false);
        console.log(error, "Error while fetching data");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [dispatch]);
  const handleClick = (link) => {
    if (link) {
      navigate(link);
    }
  };
  return (
    <>
      {loading ? (
        <div className="h-[300px]">
          <LoadingCom />
        </div>
      ) : (
        <Carousel
          afterChange={onChange}
          // autoplay
          effect="fade"
          style={{ maxWidth: "1400px" }}
          // dots={false}
          speed={100}
          fade={true}
          infinite={true}
          waitForAnimate={true}
          easing={"linear"}
          // arrows={true}
        >
          {carouselData &&
            carouselData[0]?.Data?.map((item, index) => {
              console.log(item, "itemmmmm");
              return (
                <div key={index}>
                  <div
                    className="flex flex-col justify-center items-center "
                    style={{
                      ...contentStyle,
                      cursor: item.Link ? "pointer" : "default",
                    }}
                    onClick={
                      item.Link ? () => handleClick(item.Link) : undefined
                    }
                  >
                    <img
                      style={{ width: "100%", height: "300px" }}
                      src={item?.ImageUrl}
                      alt="carousel-item"
                    />
                  </div>
                </div>
              );
            })}
        </Carousel>
      )}
    </>
  );
};
export default DashboardCarousel;
